import styled from 'styled-components';
import { media, spacing } from '@storefront/lib-global/stylings';

export const ComponentList = styled.ul`
  margin: 20px 0 0;
  max-width: 522px;
  padding: 0;

  @media ${media.greaterThan('lg')} {
    margin: ${spacing.M} 0 0;
  }
`;

export const ComponentItemBar = styled.li`
  display: flex;
  gap: ${spacing.S};
  margin-top: ${spacing.XS};

  &:nth-of-type(1) {
    margin-top: unset;
  }
`;

export const IconContainer = styled.div`
  flex-shrink: 0;
  position: relative;
`;

export const TextInfo = styled.span`
  align-items: center;
  display: flex;
  line-height: 28px;
  max-width: 310px;
  min-height: 24px;
  word-break: break-word;
`;
